import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"
import { useCreateMMW } from "../../../../../components/WMS/Transfers/MMW/useCreateMMW"

type Search = { fromWarehouseId?: string }
type RawSearch = { fromWarehouseId?: unknown }

export const Route = createFileRoute("/_layout/WMS/documents/doc-mmw/new")({
  component: DocumentMMWCreatePage,
  validateSearch: (search: RawSearch): Search => ({
    fromWarehouseId:
      typeof search.fromWarehouseId === "string"
        ? search.fromWarehouseId
        : undefined,
  }),
})

function DocumentMMWCreatePage() {
  const { fromWarehouseId } = Route.useSearch()
  const navigate = useNavigate()
  const autoCreatedRef = useRef(false)
  const { createMMW, isCreating, isResolvingWarehouses, canCreate } =
    useCreateMMW()

  const handleCancel = () => {
    if (fromWarehouseId) {
      navigate({
        to: "/WMS/warehouses/$warehouse",
        params: { warehouse: fromWarehouseId },
      })
      return
    }
    navigate({
      to: "/WMS/documents/document-list",
      search: { page: 1, page_size: 50 },
    })
  }

  useEffect(() => {
    if (autoCreatedRef.current || isResolvingWarehouses) return
    if (!canCreate) return
    autoCreatedRef.current = true
    void createMMW(fromWarehouseId)
  }, [canCreate, createMMW, fromWarehouseId, isResolvingWarehouses])

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument MMW"
      onCancel={handleCancel}
      isBusy={isCreating || isResolvingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu MMW..."
      idleLabel="Przygotowywanie edycji dokumentu MMW..."
      unavailableLabel="Brakuje dwóch aktywnych magazynów bez blokady inwentaryzacyjnej do utworzenia MMW."
    />
  )
}
